import React, { Component } from "react";
import ListMember from "./List_member";

class Member extends Component {
  constructor(props) {
    super(props);
    this.state = { tes: "" };
    this.tes = this.tes.bind(this);
  }

  tes(e) {
    this.setState({ tes: e.target.value });
  }

  render() {
    return (
      <ListMember />
    );
  }
}

export default Member;
